import React from 'react';
import { Placeholder, Stack } from 'react-bootstrap';

const ProfileSkeleton = () => {
	return (
		<>
			<div className="overview-box position-relative d-flex align-items-end">
				<div className="overview-box-bg w-100 h-100 position-absolute left-0 top-0"></div>
				<Placeholder.Button
					variant="primary"
					className="edit-btn rounded-circle p-0 border-0 position-absolute update-img"
				/>
				<div className="overview-box-inner d-flex flex-column flex-md-row w-100 gap-3 gap-md-4 align-items-md-center">
					<div className="company-profile-img position-relative">
						<Placeholder.Button
							variant="primary"
							className="edit-btn rounded-circle p-0 border-0 bg-white position-absolute update-profile"
						/>
					</div>
					<div className="overview-box-inner-details flex-1 d-flex flex-column">
						<div className="company-info-box d-flex justify-content-between gap-2">
							<div className="company-info flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={5} size="lg" />
									<Placeholder xs={8} size="sm" />
									<Placeholder xs={6} size="sm" />
								</Placeholder>
							</div>
							<div className="company-action d-flex gap-2 gap-lg-3">
								<Placeholder.Button
									variant="primary"
									className="edit-btn rounded-circle p-0 border-0 bg-white"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="about-box white-box bg-white">
				<Placeholder animation="glow">
					<Placeholder xs={3} size="lg" />
				</Placeholder>
				<div className="about-box-content">
					<Placeholder animation="glow">
						<Placeholder xs={12} size="sm" />
						<Placeholder xs={12} size="sm" />
						<Placeholder xs={12} size="sm" />
					</Placeholder>
				</div>
			</div>

			<div className="experience white-box bg-white">
				<Placeholder animation="glow">
					<Placeholder xs={2} size="lg" />
				</Placeholder>
				<div className="d-flex flex-column gap-3 gap-xxl-4">
					<div className="gray-box d-flex flex-1 position-relative gap-4">
						<div className="d-flex flex-column flex-md-row gray-box-inner flex-1">
							<div className="gray-box-logo bg-white"></div>
							<Stack className="gap-2 justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={6} size="sm" />
									<Placeholder xs={7} size="sm" />
									<Placeholder xs={12} size="sm" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
						<Placeholder.Button
							variant="primary"
							className="edit-btn rounded-circle p-0 border-0 bg-white"
						/>
					</div>
				</div>
			</div>

			<div className="educations white-box bg-white">
				<Placeholder animation="glow">
					<Placeholder xs={3} size="lg" />
				</Placeholder>
				<div className="d-flex flex-wrap gap-3 gap-xxl-4">
					<div className="gray-box d-flex flex-1 position-relative gap-4">
						<div className="d-flex flex-column flex-md-row gray-box-inner flex-1">
							<Stack className="gap-2 justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={6} size="sm" />
									<Placeholder xs={7} size="sm" />
								</Placeholder>
							</Stack>
						</div>
						<Placeholder.Button
							variant="primary"
							className="edit-btn rounded-circle p-0 border-0 bg-white"
						/>
					</div>
				</div>
			</div>

			<div className="certifications white-box bg-white">
				<Placeholder animation="glow">
					<Placeholder xs={4} size="lg" />
				</Placeholder>
				<div className="d-flex flex-column gap-3 gap-xxl-4">
					<div className="gray-box d-flex flex-1 position-relative gap-4">
						<div className="d-flex flex-column flex-md-row gray-box-inner flex-1">
							<div className="gray-box-logo bg-white"></div>
							<Stack className="gap-2 justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={6} size="sm" />
									<Placeholder xs={7} size="sm" />
								</Placeholder>
							</Stack>
						</div>
						<Placeholder.Button
							variant="primary"
							className="edit-btn rounded-circle p-0 border-0 bg-white"
						/>
					</div>
				</div>
			</div>

			<div className="academic white-box bg-white">
				<Placeholder animation="glow">
					<Placeholder xs={4} size="lg" />
				</Placeholder>
				<div className="d-flex flex-column gap-3 gap-xxl-4">
					<div className="gray-box d-flex flex-1 position-relative gap-4">
						<div className="d-flex flex-column flex-md-row gray-box-inner flex-1">
							<Stack className="gap-2 justify-content-center flex-1">
								<Placeholder animation="glow">
									<Placeholder xs={12} size="lg" />
									<Placeholder xs={6} size="sm" />
									<Placeholder xs={7} size="sm" />
									<Placeholder xs={12} size="sm" />
									<Placeholder xs={12} size="sm" />
								</Placeholder>
							</Stack>
						</div>
						<Placeholder.Button
							variant="primary"
							className="edit-btn rounded-circle p-0 border-0 bg-white"
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default ProfileSkeleton;
